import { render, staticRenderFns } from "./detailsPurchaseOrderRecord.vue?vue&type=template&id=059bf897"
import script from "./detailsPurchaseOrderRecord.vue?vue&type=script&lang=js"
export * from "./detailsPurchaseOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports